var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 3.33203C9.01102 3.33203 4.4834 4.20605 4.4834 4.20605L4.47201 4.21908C2.88323 4.47317 1.66602 5.83838 1.66602 7.4987V12.4987V12.5003V17.4987V17.5003C1.66757 18.2933 1.95174 19.0597 2.46751 19.662C2.98329 20.2643 3.69687 20.6629 4.48014 20.7865L4.4834 20.7913C4.4834 20.7913 9.01102 21.667 12.4993 21.667C15.9877 21.667 20.5153 20.7913 20.5153 20.7913L20.5169 20.7897C21.301 20.6665 22.0155 20.2675 22.5316 19.6645C23.0478 19.0615 23.3318 18.2941 23.3327 17.5003V17.4987V12.5003V12.4987V7.4987C23.3315 6.70547 23.0475 5.93866 22.5317 5.33604C22.0159 4.73342 21.3021 4.33449 20.5186 4.21094L20.5153 4.20605C20.5153 4.20605 15.9877 3.33203 12.4993 3.33203ZM9.99935 8.66406L16.666 12.4987L9.99935 16.3333V8.66406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.75ec60bdab325f5a9cc05e5cd3026275.svg";
export { ForwardRef as ReactComponent };